import React, { useEffect } from 'react';
import { Container } from 'semantic-ui-react';
import { useTranslation } from 'react-i18next';
import '../Features.css';

const Cropping = () => {
  const { t } = useTranslation();
  useEffect(() => {
    document.getElementById('home').classList.add('featureContent');
    return () => {
      document.getElementById('home').classList.remove('featureContent');
    };
  });
  useEffect(() => {
    setTimeout(() => {
      document.body.scrollTop = 0; // For Safari
      document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    }, 100);
  }, []);
  return (
    <Container className="featurePages straighten">
      <div className="header">
        <div className="headerContent">
          <h2 className="title">{t('contents:croppingTitle1')}</h2>
          <p className="text">
            {t('contents:croppingParagraph1')}
            <br />
            {t('contents:croppingParagraph2')}
            <br />
          </p>
        </div>
        <img src={require('../../../assets/images/features/pages/cropping/cropping_01.png')} />
      </div>
      <div className="content">
        <div className="container">
          <div className="section section01">
            <div className="textBox">
              <h2 className="title">{t('contents:croppingTitle2')}</h2>
              <p>{t('contents:croppingParagraph3')}</p>
            </div>
            <div className="imageBox">
              <img
                src={require('../../../assets/images/features/pages/cropping/cropping_02.png')}
              />
            </div>
          </div>
          <div className="section section02">
            <div className="textBox">
              <h2 className="title">{t('contents:croppingTitle3')}</h2>
              <p>
                {t('contents:croppingParagraph4')}
                <br />
                {t('contents:croppingParagraph5')}
              </p>
            </div>
            <div className="imageBox">
              <img
                src={require('../../../assets/images/features/pages/cropping/cropping_03.png')}
              />
            </div>
          </div>
          <div className="section section03">
            <div className="textBox">
              <h2 className="title">{t('contents:croppingTitle4')}</h2>
              <p>{t('contents:croppingParagraph6')}</p>
            </div>
            <div className="imageBox">
              <img
                src={require('../../../assets/images/features/pages/cropping/cropping_04.png')}
              />
            </div>
          </div>
          <div className="section section04">
            <div className="textBox">
              <h2 className="title">{t('contents:croppingTitle5')}</h2>
              <p>{t('contents:croppingParagraph7')}</p>
            </div>
            <div className="imageBox">
              <img
                src={require('../../../assets/images/features/pages/cropping/cropping_05.png')}
              />
            </div>
          </div>
          <div className="section section05">
            <div className="textBox">
              <h2 className="title">{t('contents:croppingTitle6')}</h2>
              <p>{t('contents:croppingParagraph8')}</p>
            </div>
            <div className="imageBox">
              <img
                src={require('../../../assets/images/features/pages/cropping/cropping_06.png')}
              />
            </div>
          </div>
        </div>
        <div className="footer"></div>
      </div>
    </Container>
  );
};

export default Cropping;
